export enum FormatOptions {
  FONT = "font",
  TEXT = "text",
  LINEHEIGHT = "lineHeight",
  MARGIN = "margin",
  MODE = "mode",
}
